'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from 'react';
import { SaveButton } from '~/components/Common/SaveButton';
import ShareButton from '~/components/Common/ShareButton/src/ShareButton';
import useJourneyData from '~/hooks/useJourneyData';
import useTripDisplayTitle from '~/hooks/useTripDisplayTitle';
import styles from './StickyTripHeader.module.css';
const REVEAL_AT_SCROLL_PX = 700;
function useScrollReveal(minPixels) {
  const $ = _c(3);
  const [show, setShow] = useState(false);
  const lastY = useRef(0);
  const ticking = useRef(false);
  let t0;
  let t1;
  if ($[0] !== minPixels) {
    t0 = () => {
      const update = () => {
        const y = globalThis.scrollY;
        if (Math.abs(y - lastY.current) >= 5) {
          const goingUp = y < lastY.current;
          setShow(goingUp && y >= minPixels);
          lastY.current = y <= 0 ? 0 : y;
        }
        ticking.current = false;
      };
      const onScroll = () => {
        if (!ticking.current) {
          requestAnimationFrame(update);
          ticking.current = true;
        }
      };
      globalThis.addEventListener("scroll", onScroll, {
        passive: true
      });
      return () => globalThis.removeEventListener("scroll", onScroll);
    };
    t1 = [minPixels];
    $[0] = minPixels;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return show;
}
export function StickyTripHeader() {
  const $ = _c(12);
  const {
    uniqueId,
    details
  } = useJourneyData();
  const title = useTripDisplayTitle();
  const show = useScrollReveal(REVEAL_AT_SCROLL_PX);
  if (process.env.NEXT_PUBLIC_FF_TRIP_SAVE_SHARE_NAV !== "true") {
    return null;
  }
  if (!show) {
    return null;
  }
  let t0;
  if ($[0] !== title) {
    t0 = <p className={`${styles.title} typography-title-6`}>{title}</p>;
    $[0] = title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ShareButton iconOnly={true} />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== details?.endDate || $[4] !== details?.startDate || $[5] !== uniqueId) {
    t2 = uniqueId && <SaveButton tripId={uniqueId} startDate={details?.startDate} endDate={details?.endDate} iconOnly={true} />;
    $[3] = details?.endDate;
    $[4] = details?.startDate;
    $[5] = uniqueId;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <div className={styles.actions}>{t1}{t2}</div>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t0 || $[10] !== t3) {
    t4 = <div className={styles.header}>{t0}{t3}</div>;
    $[9] = t0;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}